import type { BinaryReadOptions, DescMessage } from '@bufbuild/protobuf';
import { fromBinary } from '@bufbuild/protobuf';

import { decodeTrailer } from './decode-trailer';
import type { Envelope } from './envelope';
import type { GrpcNext } from './grpc-next';
import { GrpcOutput } from './grpc-output';
import { FETCH_HEADERS } from './grpc-headers';

export class MessageDecodeStream<D extends DescMessage> extends TransformStream<
  Envelope[],
  GrpcNext<D>[]
> {
  constructor(
    private readonly schema: D,
    private readonly options?: Partial<BinaryReadOptions>,
  ) {
    super({
      transform: (envelops, controller) => {
        controller.enqueue(
          envelops.map((envelope) => {
            let { flags, bytes }: Envelope = envelope;
            switch (flags) {
              case 0b00000000:
                return new GrpcOutput<D>(
                  fromBinary<D>(this.schema, bytes, this.options),
                );
              case 0b10000000:
                return FETCH_HEADERS.provide(decodeTrailer(bytes));
              default:
                throw new Error('Not implemented');
            }
          }),
        );
      },
    });
  }
}
